module.exports = __webpack_public_path__ + "static/media/quote.f232133e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/GameSelector/images/quote.svg
// module id = 202
// module chunks = 0